export default __webpack_public_path__ + "static/media/right-arrow.f79b086f.svg";